import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "label" }

import { computed, markRaw } from 'vue';

import * as nativex from '@native';

import { config } from '@services/user-config';
import { t } from '@services/l10n';
import MobileBottomBar from '@components/MobileBottomBar.vue';

import ImageMultipleIcon from 'vue-material-design-icons/ImageMultiple.vue';
import SearchIcon from 'vue-material-design-icons/Magnify.vue';
import AlbumIcon from 'vue-material-design-icons/ImageAlbum.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileNav',
  setup(__props) {

const links = computed(() => {
  const list = [
    { to: '/', icon: markRaw(ImageMultipleIcon), text: t('memories', 'Photos') },
    { to: '/explore', icon: markRaw(SearchIcon), text: t('memories', 'Explore') },
  ];
  if (config.albums_enabled) {
    list.push({ to: '/albums', icon: markRaw(AlbumIcon), text: t('memories', 'Albums') });
  }
  return list;
});

function beep() {
  nativex.playTouchSound();
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(MobileBottomBar, { id: "mobile-nav" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: link.to,
          to: link.to,
          class: "mobile-bottom-bar-item",
          onClick: beep,
          replace: "",
          "exact-path": ""
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(link.icon), { size: 22 })),
            _createElementVNode("span", _hoisted_1, _toDisplayString(link.text), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})